import { brandLogos } from '@liveauctioneers/hammer-ui-core/brandAssets';
import { Link, SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';

import LiveAuctionSettingsMenu from '@/pages/BiddingConsole/components/LiveAuctionSettingsMenu/LiveAuctionSettingsMenu';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogSellerId,
    getCatalogSellerName,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogUrl, getHomeUrl, getSellerUrl } from '@/utils/urls';

type Props = {
    catalogId: number;
    onCurrencyChanged: (value) => void;
    selectedCurrency: string;
};

const AuctionNameAndSettingsBlock = ({ catalogId, onCurrencyChanged, selectedCurrency }: Props) => {
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const catalogSellerName = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const catalogUrl = useAppSelector(() => getCatalogUrl(catalogId, catalogTitle));
    const sellerUrl = useAppSelector(() => getSellerUrl(sellerId, catalogSellerName));

    return (
        <div className="mb-sm border border-border-secondary bg-background-primary p-md">
            <div className="mb-sm flex items-center justify-between">
                <Link
                    href={getHomeUrl()}
                    target="_blank"
                >
                    <img
                        alt="LiveAuctioneers"
                        className="h-[24px] w-[179px]"
                        data-testid="la-logo-asset"
                        src={brandLogos.LiveAuctioneers.brand}
                    />
                </Link>
                <LiveAuctionSettingsMenu
                    catalogId={catalogId}
                    onCurrencyChanged={onCurrencyChanged}
                    selectedCurrency={selectedCurrency}
                />
            </div>
            <SubtleMonochromeLink
                href={catalogUrl}
                target="_blank"
            >
                {catalogTitle}
            </SubtleMonochromeLink>
            <br />
            <SubtleMonochromeLink
                href={sellerUrl}
                target="_blank"
            >
                {catalogSellerName}
            </SubtleMonochromeLink>
        </div>
    );
};

export default AuctionNameAndSettingsBlock;
